import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { cn } from "@/lib/utils";
import { useBranding } from "@/hooks/useBranding";

export const SidebarLogo = ({ collapsed }) => {
  const currentTheme = useSelector((state) => state.theme.theme);
  const isDark = currentTheme === "dark";
  const { branding } = useBranding();

  const logoSrc = isDark
    ? branding?.logoDarkUrl || branding?.logoUrl || "/logo_dark.svg"
    : branding?.logoUrl || branding?.logoDarkUrl || "/logo_light.svg";

  const altText = branding?.displayName || "IMS People Possible AI logo";

  return (
    <div className={cn("flex justify-center", collapsed ? "mb-3" : "mb-4")}>
      <Link
        to="/"
        title={collapsed ? altText : undefined}
        aria-label={altText}
        className="inline-flex items-center justify-center"
      >
        <img
          src={logoSrc}
          alt={altText}
          className={cn(
            "object-contain shrink-0",
            collapsed ? "h-9 w-10" : "h-12 w-auto max-w-[132px]"
          )}
        />
      </Link>
    </div>
  );
};
